<template>
  <div class="control-module">
    <div class="on-off card" :class="{'card-on': equipmentState.run === 1}" @click="turn">
      <span class="text">{{ equipmentState.run === 0 ? 'off' : 'on' }}</span>
      <svg-icon icon-class="开机" :color="equipmentState.run === 0 ? '#999999' : '#ffffff'"></svg-icon>
    </div>
    <!--  模式  -->
    <div class="mode">
      <div v-for="(item,index) in modeList" :key="'mode'+index" @click="equipmentState.run === 1 ? changeMode(item) : null">
        <div class="card" :class="equipmentState.mode === item.value ? (equipmentState.run === 1 ? 'card-on' : 'choose-off') : ''">
          <svg-icon :icon-class="item.icon" :color="(equipmentState.mode === item.value && equipmentState.run === 1) ? '#ffffff' : '#999999'"></svg-icon>
        </div>
        <div>{{ item.label }}</div>
      </div>
    </div>

    <div class="other">
      <div class="left">
        <div v-for="(item, index) in windTypeList" :key="'other' +index" @click="equipmentState.run === 1 ? changeWindType(item) : null">
          <div class="card" :class="item.value === 1 ? (equipmentState.run === 1 ? 'card-on' : 'choose-off') : ''">
            <svg-icon :icon-class="item.icon" :color="(item.value === 1 && equipmentState.run === 1) ? '#ffffff' : '#999999'"></svg-icon>
          </div>
          <div class="name">{{item.label}}</div>
        </div>
      </div>
      <div class="right">
        <div>
          <div class="card">
            <div class="logo">
              <svg-icon icon-class="温度" color="#999999"></svg-icon>
              <div class="text">温度</div>
            </div>
            <div class="panel-out" :style="{backgroundColor: equipmentState.run === 1 ? (equipmentState.mode === 4 ? '#F47878' : equipmentState.mode === 2 ? '#54ADF5' : '#CCCCCC') : '#CCCCCC'}">
              <div class="panel-in">
                <div class="temp">
                  <template v-if="equipmentState.run === 1">
                    <span class="num">{{equipmentState.tempSet}}</span>
                    <span> ℃</span>
                  </template>
                  <span v-else>----</span>
                </div>
                <div class="label">当前温度</div>
              </div>
            </div>
            <div class="btn btn-left" @click="equipmentState.mode !== 5 ? changeTemp('down') : null">
              <svg-icon icon-class="向左" :color="tempBtnColorDown"></svg-icon>
            </div>
            <div class="btn btn-right" @click="equipmentState.mode !== 5 ? changeTemp('up') : null">
              <svg-icon icon-class="向右" :color="tempBtnColorUp"></svg-icon>
            </div>
          </div>
        </div>
        <div>
          <div class="card">
            <svg-icon icon-class="风扇-copy" color="#999999"></svg-icon>
            <div class="slider">
              <div class="bg" :style="{width: equipmentState.wind + '%'}"></div>
              <van-slider :disabled="equipmentState.isAutoWind === 1 || equipmentState.run === 0 || (equipmentState.run === 1 && (equipmentState.mode === 1 || equipmentState.mode === 3))" @change="subChange" v-model="equipmentState.wind" :step="1" bar-height="6px" active-color="transparent" :min="0" :max="100"/>
            </div>
          </div>
          <div class="name">风速</div>
        </div>
      </div>
    </div>
    <van-dialog v-model="dialogParam.show" title="" show-cancel-button confirm-button-text="重新连接" @confirm="getEquipmentState" confirm-button-color="#008BF6" cancel-button-color="#999999">
      <div style="text-align: center;padding: 50px 20px">
        <van-icon name="warning-o" color="red"></van-icon>&nbsp;
        {{dialogParam.message}}
      </div>
    </van-dialog>
  </div>
</template>

<script>

export default {
  name: 'controlModule',
  props: {
    equipmentInfo: Object
  },
  data() {
    return{
      isEquipmentConnect: false,
      equipmentState: {
        mode: 4,
        windLeftRight: 0,
        windUpDown: 0,
        run: 0,
        tempSet: 24.5,
        wind: 0,
        isAutoWind: 0,
      },
      loading: false,
      modeList: [
        { label: '制热', icon: '制热', value: 4 },
        { label: '制冷', icon: '制冷', value: 2 },
        { label: '除湿', icon: '除湿', value: 3 },
        { label: '送风', icon: '送风', value: 5 },
        { label: '自动', icon: '自动', value: 1 },
      ],
      windTypeList: [
        { label: '左右扫风', value: 1, code: 'windLeftRight', icon: '左右扫风' },
        { label: '上下扫风', value: 0, code: 'windUpDown', icon: '上下扫风' },
        { label: '自动风', value: 0, code: 'isAutoWind', icon: '自动风' },
      ],
      dialogParam: {
        show: false,
        message: ''
      }
    }
  },
  computed: {
    tempBtnColorUp() {
      return (this.equipmentState.run === 1 && this.equipmentState.tempSet < 30) ? '#999999' : '#EEEEEE'
    },
    tempBtnColorDown() {
      return (this.equipmentState.run === 1 && this.equipmentState.tempSet > 17) ? '#999999' : '#EEEEEE'
    }
  },
  methods: {
    // 开关
    turn() {
      if(this.isEquipmentConnect) {
        this.subChange('run', this.equipmentState.run ? 0 : 1)
      } else {
        this.dialogParam.show = true
      }
    },
    // 扫风类型
    async changeWindType(item) {
      await this.subChange(item.code, item.value ? 0 : 1)
    },
    // 温度
    changeTemp(type) {
      if(this.equipmentState.run === 1) {
        let temp = this.equipmentState.tempSet
        // 17~30
        if (type === 'up' && this.equipmentState.tempSet < 30) {
          temp = temp + 0.5
          this.subChange('tempSet', temp)
        }
        if (type === 'down' && this.equipmentState.tempSet > 17) {
          temp = temp - 0.5
          this.subChange('tempSet', temp)
        }
      }
    },
    // 提交
    async subChange(code,val){
      this.openLoading('open', '正在操作中')
      try {
        const params = JSON.parse(JSON.stringify(this.equipmentState))
        params[code] = val
        params.DeviceSn = this.equipmentInfo.DeviceSn
        //自动和除湿模式不能调整风速
        if(params.mode === 1 || params.mode === 3) {
          delete params.wind
        }
        //送风模式不能调整温度
        if(params.mode === 5) {
          delete params.tempSet
        }
        const { Data } = await this.$post('/BizMemberEquipment/ControlEquipment', params)
        if (Data.errCode === '0') {
          this.isEquipmentConnect = true
          this.openLoading('close')
          this.$toast.success('操作成功')
          await this.changeValue(code, val)
        } else {
          this.isEquipmentConnect = false
          this.openLoading('close')
          this.dialogParam.show = true
          this.dialogParam.message = Data.errMsg
        }
      }catch (e) {
        this.isEquipmentConnect = false
        this.openLoading('close')
      }
    },
    // 保存成功后对应值修改
    changeValue(code, value) {
      if (code === 'isAutoWind') {
        this.$set(this.equipmentState, 'wind', value === 1 ? 102 : 0)
      }
      const index = this.windTypeList.findIndex(cur => cur.code === code)
      if (index > -1) {
        this.$set(this.windTypeList[index], 'value', value)
      }
      this.$set(this.equipmentState, code, value)
    },
    async getEquipmentState() {
      this.loading = true
      this.openLoading('open')
      try {
        const params = {
          DeviceSn: this.equipmentInfo.DeviceSn
        }
        const { Data } = await this.$post('/BizMemberEquipment/EquipmentState', params)
        if (Data.errCode === '0') {
          this.isEquipmentConnect = true
          this.equipmentState = Data.result
          this.windTypeList.forEach(item => {
            item.value = Data.result[item.code]
          })
        } else {
          this.isEquipmentConnect = false
          this.dialogParam.show = true
          this.dialogParam.message = Data.errMsg
        }
        this.openLoading('close')
        this.loading = false
      }catch (e) {
        this.isEquipmentConnect = false
        this.openLoading('close')
        this.loading = false
      }
    },
    openLoading(type, text='加载中') {
      if (type === 'open') {
        this.$toast.loading({
          mask: true,
          message: text,
          duration: 0,
          className: 'loading-style',
        })
      }else {
        this.$toast.loading().clear()
      }
    },
    // 切换模型
    async changeMode(item){
      //除制冷制热模式外，都不能调整风速
      if(item.value === 1 || item.value === 3) {
        this.$set(this.equipmentState, 'wind', 102)
      }
      else {
        if(this.equipmentState.isAutoWind === 0) {
          this.$set(this.equipmentState, 'wind', 0)
        }
      }
      await this.subChange('mode', item.value)
    }
  },
  mounted() {
    this.getEquipmentState()
  }
}

</script>

<style scoped lang="less">
.control-module{
  width: 100%;
  color: #999999;
  .card{
    background-color: #ffffff;
    box-shadow: 0 0 10px #dcdee0;
    padding: 15px;
    border-radius: 10px;
  }

  .card-on{
    background-color: #19D632!important;
    color: #ffffff;

    .svg-icon{

    }
  }

  // 空调关闭时的选中状态
  .choose-off{
    background-color: #CCCCCC;
  }

  // 开关按钮
  .on-off{
    height: 60px;
    text-align: center;
    position: relative;
    background-color: #CCCCCC;
    .text{
      position: absolute;
      left: 25px;
      top: 24px;
    }

    .svg-icon{
      font-size: 30px;
    }
  }

  //模式
  .mode{
    display: flex;
    width: 100%;
    margin-top: 15px;
    >div{
      margin-right: 10px;
      width: 100%;
      text-align: center;


      .card{
        width: 100%;
        aspect-ratio: 1;
        margin-bottom: 6px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      &:last-child{
        margin-right: 0;
      }
    }

    .svg-icon{
      font-size: 24px;
    }
  }

  // 其他操作
  .other{
    margin-top: 15px;
    display: flex;
    width: 100%;
    .left{
      flex: 1;
      display: flex;
      flex-direction: column;
      margin-right: 10px;
      >div{
        height: 100%;
        margin-bottom: 10px;
        display: flex;
        flex-direction: column;

        .card{
          height: 100%;
          margin-bottom: 8px;
          display: flex;
          justify-content: center;
          align-items: center;
          .svg-icon{
            font-size: 30px;
          }
        }

        &:last-child{
          margin-bottom: 0;
        }
      }
    }
    .right{
      flex: 3.5;
      >div{

        &:nth-child(1){
          width: 100%;
          aspect-ratio: 1;
          margin-bottom: 10px;
          .card{
            aspect-ratio: 1;
            margin-bottom: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            .logo{
              position: absolute;
              left: 20px;
              top: 20px;
              text-align: center;
              .text{
                margin-top: 4px;
                font-size: 12px;
              }
              .svg-icon{
                font-size: 30px;
              }
            }

            .panel-out{
              width: 70%;
              aspect-ratio: 1;
              border-radius: 50%;
              background-color: #00b3f3;
              display: flex;
              justify-content: center;
              align-items: center;
              box-shadow: 0 0 8px #CCCCCC inset;
              margin-bottom: 10px;
              .panel-in{
                width: 92%;
                aspect-ratio: 1;
                border-radius: 50%;
                background-color: #ffffff;
                box-shadow: 0 0 8px #CCCCCC;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                .temp{
                  line-height: 28px;
                  .num{
                    color: #919191;
                    font-size: 28px;
                  }
                }

              }

            }

            .btn{
              position: absolute;


              .svg-icon{
                font-size: 30px;
              }

              &.btn-left{
                bottom: 20px;
                left: 25px;
              }
              &.btn-right{
                bottom: 20px;
                right: 25px;
              }
            }



          }
        }
        &:nth-child(2){
          height: 120px;
          display: flex;
          flex-direction: column;
          .card{
            height: 100%;
            margin-bottom: 8px;
            display: flex;
            align-items: center;

            .slider{
              height: 4px;
              width: 100%;
              background-color: #CCCCCC;
              border-radius: 4px;

              .bg{
                height: 4px;
                background: linear-gradient(to right, #19D632, #008BF6);
                border-radius: 4px;
              }
              .van-slider{
                margin-top: -5px;
                background-color: transparent;
              }
              .van-slider--disabled{
                opacity: 1;
              }
              ::v-deep.van-slider__button{
                width: 10px;
                height: 10px;
                box-shadow: none;
                border: 1px solid #008BF6;
              }
            }

            .svg-icon{
              font-size: 30px;
              margin-right: 15px;
            }
          }
        }
      }
    }


    .name{
      text-align: center;
    }
  }




}
</style>
<style lang="less">
.van-overlay{
  background-color: rgba(0,0,0,.5)!important;
}
.loading-style{
  background-color: rgba(0,0,0,.5)!important;
}
</style>
